import { z } from 'zod'

export const apiKeySchema = z.string().regex(/^nif_live_[a-f0-9]{32}$/)
